module.exports = __webpack_public_path__ + "img/noises-13.75ad25cc.jpg";